<script>
  export let onClose;

  let notify = true;
  let darkMode = false;
  let enterToSend = true;
  let autoScroll = true;

  function save() {
    // TODO: lưu setting vào store / localStorage / backend
    onClose?.();
  }
</script>

<!-- HEADER -->
<div class="flex items-center justify-between mb-4">
  <h3 class="text-lg font-semibold text-gray-900">Cài đặt</h3>

  <button class="text-gray-400 hover:text-gray-600 text-xl" on:click={onClose}>✕</button>
</div>

<!-- BODY -->
<div class="space-y-6 text-sm text-gray-700">
  <!-- ===== GENERAL ===== -->
  <section>
    <h4 class="text-xs font-semibold text-gray-400 uppercase mb-2">Chung</h4>

    <div class="space-y-3">
      <label class="flex items-center justify-between">
        <span>Thông báo</span>
        <input type="checkbox" bind:checked={notify} class="accent-blue-500" />
      </label>

      <label class="flex items-center justify-between">
        <span>Chế độ tối</span>
        <input type="checkbox" bind:checked={darkMode} class="accent-blue-500" />
      </label>
    </div>
  </section>

  <!-- ===== CHAT ===== -->
  <section>
    <h4 class="text-xs font-semibold text-gray-400 uppercase mb-2">Trò chuyện</h4>

    <div class="space-y-3">
      <label class="flex items-center justify-between">
        <span>Enter để gửi</span>
        <input type="checkbox" bind:checked={enterToSend} class="accent-blue-500" />
      </label>

      <label class="flex items-center justify-between">
        <span>Tự cuộn khi có tin mới</span>
        <input type="checkbox" bind:checked={autoScroll} class="accent-blue-500" />
      </label>
    </div>
  </section>

  <!-- ===== ACCOUNT ===== -->
  <section>
    <h4 class="text-xs font-semibold text-gray-400 uppercase mb-2">Tài khoản</h4>

    <button
      class="w-full py-2 text-red-600
             bg-red-50 rounded-lg
             hover:bg-red-100 transition">
      Đăng xuất
    </button>
  </section>
</div>

<!-- FOOTER -->
<div class="mt-6 flex gap-3">
  <button
    class="flex-1 py-2 rounded-lg
           bg-gray-100 hover:bg-gray-200"
    on:click={onClose}>
    Huỷ
  </button>

  <button
    class="flex-1 py-2 rounded-lg
           bg-blue-600 text-white
           hover:bg-blue-700"
    on:click={save}>
    Lưu
  </button>
</div>
